module.exports = __webpack_public_path__ + "img/pic_right.0a5ec855.svg";